"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCancelableRequest = createCancelableRequest;
exports.isAbortError = void 0;

var isAbortError = function isAbortError(err) {
  return err && err.name === "AbortError";
};

exports.isAbortError = isAbortError;

function createCancelableRequest(fn) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$resolveDefValueO = _ref.resolveDefValueOnAbort,
      resolveDefValueOnAbort = _ref$resolveDefValueO === void 0 ? undefined : _ref$resolveDefValueO;

  return function () {
    var controller = new AbortController();

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var result = fn.apply(void 0, args.concat([{
      signal: controller.signal
    }]));

    if (result && typeof result.then === "function") {
      var fulfilled = false;
      var promise = result["catch"](function (err) {
        if (!isAbortError(err)) {
          throw err;
        }

        return resolveDefValueOnAbort;
      })["finally"](function (r) {
        fulfilled = true;
        return r;
      });

      promise.abort = function () {
        if (!fulfilled) {
          controller.abort();
          fulfilled = true;
        }
      };

      return promise;
    }

    return result;
  };
}